import React from 'react';
import { OverviewController, OverviewControllerProps } from './Overview.controller';
import { gql } from '@apollo/client';
import { useGetAnalyticsOverviewDataLazyQuery } from '../../../../models/graphql';

gql`
  query GetAnalyticsOverviewData($startDate: String!, $endDate: String!, $selectedProfilesIds: [ID!]!) {
    analyticsFollowers(
      socialProfileIds: $selectedProfilesIds
      groupByDate: true
      rangeStartDate: $startDate
      rangeEndDate: $endDate
    ) {
      socialProfileId
      previousPeriodStats {
        rangeStartDate
        rangeEndDate
        followers
      }
      followersStats {
        rangeStartDate
        rangeEndDate
        followers
      }
    }
    analyticsPostStats(
      socialProfileIds: $selectedProfilesIds
      rangeStartDate: $startDate
      rangeEndDate: $endDate
      groupByType: PROFILE
      groupByDate: false
    ) {
      postStatsByProfile {
        socialProfileId
        postStats {
          postCount
          rangeStartDate
          rangeEndDate
          likes
          comments
          shares
          impressions
        }
      }
    }
  }
`;
export const OverviewApollo = () => {
  const [getData, { data, loading }] = useGetAnalyticsOverviewDataLazyQuery();

  const props: OverviewControllerProps = {
    getAnalyticsDataQuery: getData,
    loading,
    overviewData: data
  };
  return <OverviewController {...props}></OverviewController>;
};
